import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute, RenderComponent } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { Route } from '@packages/router/lib/route';
import React from 'react';
import { LogoutPage } from './LogoutPage';

const SignInPage = AsyncPageRender(() => pageModule(import('./SignIn')));
const SignUpPage = AsyncPageRender(() => pageModule(import('./SignUp')));
const ForgotPasswordPage = AsyncPageRender(() => pageModule(import('./ForgotPassword')));
const ResetPasswordPage = AsyncPageRender(() => pageModule(import('./ResetPassword')));

function Router() {
    return (
        <>
            <Route name={'auth.logout'} exact path={'/logout'} component={LogoutPage} />
            <Route
                name={'auth.sign-in'}
                exact
                path={'/sign-in'}
                component={ProtectedRoute(SignInPage, { required: false, redirectURL: '/' })}
            />
            <Route
                name={'auth.customer.sign-up'}
                exact
                path={'/sign-up'}
                component={RenderComponent(SignUpPage, true)}
            />
            <Route name={'auth.forget'} exact path={'/forgot'} component={RenderComponent(ForgotPasswordPage, true)} />
            <Route
                name={'auth.reset-password'}
                exact
                path={'/auth/reset/:token'}
                component={RenderComponent(ResetPasswordPage, true)}
            />
        </>
    );
}

export default Router;
